import React, { useContext, useEffect, useRef, useState } from "react";
import {
  getPortalSettings,
  sendDepositRequest,
} from "../../../../API/depositAPI";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import AuthContext from "../../../../Auth/AuthContext";
import * as Yup from "yup";
import { verifyToken } from "../../../../API/authAPI";
import { CURRENCY_SYMBOL } from "../../../../constants";
const SelectAmount = ({
  amount,
  setAmount,
  token,
  paymentSelectedMethod,
  formData,
  setFormData,
}) => {
  const [amounts, setAmounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [bounds, setBounds] = useState({ min: null, max: null });
  const [error, setError] = useState("");
  const inputRef1 = useRef();
  const inputRef2 = useRef();
  const inputRef3 = useRef();
  const inputRef4 = useRef();
  const inputRef5 = useRef();
  const [copied1, setCopied1] = useState(false);
  const [copied2, setCopied2] = useState(false);
  const [copied3, setCopied3] = useState(false);
  const [copied4, setCopied4] = useState(false);
  const [copied5, setCopied5] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const settings = await getPortalSettings("deposit", token);
        const min = Number(settings?.min_deposit);
        const max = Number(settings?.max_deposit);

        if (
          !Number.isFinite(min) ||
          !Number.isFinite(max) ||
          min <= 0 ||
          min >= max
        ) {
          setAmounts([]);
          setBounds({ min: null, max: null });
        } else {
          setBounds({ min, max });
          setAmounts(generateFourButtons(min, max));
        }
      } catch (err) {
        console.error("Failed to fetch portal settings:", err);
        setAmounts([]);
        setBounds({ min: null, max: null });
      } finally {
        setLoading(false);
      }
    })();
  }, [token]);

  /* ---------- handlers ---------- */
  const handleSelectAmount = (value) => {
    setAmount(String(value));
    setError(""); // quick-pick is always valid
  };

  const handleAmountChange = (e) => {
    const val = e.target.value;
    setAmount(val);

    if (val === "") return setError("");

    const num = Number(val);
    if (!Number.isFinite(num)) {
      setError("Enter a valid number");
      return;
    }
    const { min, max } = bounds;
    if (min != null && num < min) {
      setError(
        `Minimum allowed is ${CURRENCY_SYMBOL} ${min.toLocaleString("en-IN")}`
      );
    } else if (max != null && num > max) {
      setError(
        `Maximum allowed is ${CURRENCY_SYMBOL} ${max.toLocaleString("en-IN")}`
      );
    } else {
      setError("");
    }
  };

  const handleAmountBlur = () => {
    const num = Number(amount);
    if (!Number.isFinite(num)) return;
    const { min, max } = bounds;
    let v = num;
    if (min != null && v < min) v = min;
    if (max != null && v > max) v = max;
    if (v !== num) setAmount(String(v));
  };

  // copy number
  const handleCopy = (ref, setCopied) => {
    if (ref.current) {
      const textToCopy = ref.current.value;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(textToCopy)
          .then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
          })
          .catch((err) => {
            console.error("Clipboard API failed", err);
            toast.error("Copy failed. Try manually.");
          });
      } else {
        try {
          // ✅ Create a temporary textarea for fallback
          const textarea = document.createElement("textarea");
          textarea.value = textToCopy;
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);

          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        } catch (error) {
          toast.error("Copy not supported in this browser.");
        }
      }
    }
  };

  // upload photo Starts
  // console.log("testing from the request deposit", paymentSelectedMethod);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate(); // Navigation function
  const { user } = useContext(AuthContext);
  // const token = user?.token;
  const formik = useFormik({
    enableReinitialize: true, // 🟣 IMPORTANT!
    initialValues: {
      amount: amount || "",
      // utr_number: "",
      // payment_screenshot: null,
      // amount: formData.amount,
      paymentSelectedMethod: formData.paymentSelectedMethod,
      utr_number: formData.utr_number,
      payment_screenshot: formData.payment_screenshot,
    },
    validationSchema: Yup.object({
      utr_number: Yup.string().required("UTR number is required"),
      amount: Yup.string().required("Amount is required"),
    }),
    onSubmit: async (values, { setSubmitting, setErrors, resetForm }) => {
      try {
        // ✅ Step 1: Verify token with its own error handler
        let tokenRes;
        try {
          tokenRes = await verifyToken(token);
          if (tokenRes.status !== "success") {
            setErrors({
              api:
                tokenRes.message ||
                "Invalid or expired token. Please log in again.",
            });
            setSubmitting(false);
            return;
          }
        } catch (verifyError) {
          const errorMessage =
            verifyError.response?.data?.message ||
            "Invalid or expired token. Please log in again.";
          setErrors({ api: errorMessage });
          setSubmitting(false);
          return;
        }

        // ✅ Step 2: Prepare formData
        const formData = new FormData();
        formData.append("payment_detail_id", 2);
        formData.append("amount", values.amount);
        formData.append("utr", values.utr_number);
        if (values.payment_screenshot) {
          formData.append("image", values.payment_screenshot);
        }

        // ✅ Step 3: Send deposit request
        const response = await sendDepositRequest({
          token,
          amount: values.amount,
          utr_number: values.utr_number,
          payment_screenshot: values.payment_screenshot,
          paymentSelectedMethod: paymentSelectedMethod,
        });

        // ✅ Step 4: Handle success/failure
        if (response.status === "success") {
          // alert("Deposit request sent successfully!");
          setShowModal(true);
          resetForm();
          // navigate(routes.transactions.depositHistory);
        } else {
          setErrors({
            api: response.data.message || "Failed to send deposit request.",
          });
        }
      } catch (error) {
        // catch (error) {
        //   // ✅ Step 5: General error fallback
        //   // if (error.response) {
        //   //   const serverMessage =
        //   //     error.response.data?.msg || // ✅ use "msg" instead of "message"
        //   //     "Something went wrong!";
        //   //   setErrors({ api: serverMessage });
        //   // } else if (error.request) {
        //   //   setErrors({ api: "Server not responding. Please try again later." });
        //   // } else {
        //   //   setErrors({ api: "Something went wrong. Try again." });
        //   // }
        //   if (error.response) {
        //     setErrors({ api: error.response.data.message || "Invalid request" });
        //   } else if (error.request) {
        //     setErrors({ api: "Server not responding. Please try again later." });
        //   } else {
        //     setErrors({ api: "Something went wrong. Try again." });
        //   }
        // }
        if (error.response) {
          const data = error.response.data;
          const apiErrors = new Set();

          // ✅ Collect Laravel-style validation errors
          if (data.errors) {
            Object.values(data.errors).forEach((fieldErrors) => {
              fieldErrors.forEach((msg) => apiErrors.add(msg));
            });
          }

          // ✅ Add message only if not already included
          if (data.msg && !apiErrors.has(data.msg)) {
            apiErrors.add(data.msg);
          }
          // if (data.message && !apiErrors.has(data.message)) {
          //   apiErrors.add(data.message);
          // }

          if (apiErrors.size === 0) {
            apiErrors.add("Something went wrong.");
          }

          // ✅ Set final cleaned list to formik
          setErrors({ api: Array.from(apiErrors) });
        } else if (error.request) {
          setErrors({
            api: ["Server not responding. Please try again later."],
          });
        } else {
          setErrors({ api: ["Something went wrong. Try again."] });
        }
      }
      setSubmitting(false);
    },
  });

  // ✅ Handle File Upload
  // const handleFileChange = (event) => {
  // const file = event.currentTarget.files[0];
  // formik.setFieldValue("payment_screenshot", file);
  // };
  const handleFileChange = (event) => {
    const file = event.currentTarget.files[0];
    formik.setFieldValue("payment_screenshot", file);

    setFormData((prev) => ({
      ...prev,
      payment_screenshot: file,
    }));
  };
  // upload photo Ends

  return (
    <div className="card bg_light_grey account_input-textbox-container">
      <div className="card-body py-4 pb-5">
        <h5 className="mb-3">Select Amount</h5>

        <form
          className="form-control_container"
          onSubmit={(e) => e.preventDefault()}
        >
          <div className="input-field mb-1">
            <input
              required
              className={`input ${error ? "is-invalid" : ""}`}
              type="number"
              value={amount}
              min={bounds.min ?? undefined}
              max={bounds.max ?? undefined}
              onChange={handleAmountChange}
              onBlur={handleAmountBlur}
              inputMode="numeric"
            />
            <label className="label" htmlFor="input">
              Enter the Amount or select the Amount
            </label>
          </div>

          {/* hint / error */}
          {error ? (
            <small className="text-danger d-block mb-3">{error}</small>
          ) : bounds.min != null && bounds.max != null ? (
            <small className="text-muted d-block mb-3">
              Allowed range: {CURRENCY_SYMBOL}{" "}
              {bounds.min.toLocaleString("en-IN")} – {CURRENCY_SYMBOL}{" "}
              {bounds.max.toLocaleString("en-IN")}
            </small>
          ) : null}

          <div className="recharge-amount-container button">
            {loading
              ? [0, 1, 2, 3].map((i) => (
                <button key={i} type="button" className="btn" disabled>
                  ...
                </button>
              ))
              : amounts.map((amt, idx) => (
                <button
                  key={idx + "-" + amt}
                  type="button"
                  className="btn"
                  onClick={() => handleSelectAmount(amt)}
                  title={
                    idx === 0
                      ? `Min ({CURRENCY_SYMBOL} ${amt.toLocaleString(
                        "en-IN"
                      )})`
                      : idx === 3
                        ? `Max ({CURRENCY_SYMBOL} ${amt.toLocaleString(
                          "en-IN"
                        )})`
                        : `{CURRENCY_SYMBOL} ${amt.toLocaleString("en-IN")}`
                  }
                >
                  {amt.toLocaleString("en-IN")}
                </button>
              ))}
          </div>

          {/* Bank Details Starts */}
          <div className="card account_input-textbox-container border-0">
            <div className="card-body pt-0 py-0">
              <h5 className="mb-0">Bank Details</h5>
              <div className="form-control_container">
                <div className="input-field mb-3">
                  <input
                    required
                    className="input"
                    type="text"
                    // value={paymentDetails?.bank_name}
                    value={"JACK"}
                    readOnly
                    ref={inputRef1}
                    disabled
                  />
                  <div
                    className="position-absolute copy-text"
                    style={{
                      right: "10px",
                      top: "60%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  >
                    <button onClick={() => handleCopy(inputRef1, setCopied1)}>
                      <i className="fa-solid fa-copy text-white fs-5"></i>
                    </button>
                    {copied1 && <span className="copied-tooltip">Copied</span>}
                  </div>
                </div>
                <div className="input-field mb-3">
                  <input
                    required
                    className="input"
                    type="text"
                    // value={paymentDetails.account_holder_name}
                    value={"Indian"}
                    readOnly
                    ref={inputRef2}
                    disabled
                  />
                  <div
                    className="position-absolute copy-text"
                    style={{
                      right: "10px",
                      top: "60%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  >
                    <button onClick={() => handleCopy(inputRef2, setCopied2)}>
                      <i className="fa-solid fa-copy text-white fs-5"></i>
                    </button>
                    {copied2 && <span className="copied-tooltip">Copied</span>}
                  </div>
                </div>
                <div className="input-field mb-3">
                  <input
                    required
                    className="input"
                    type="text"
                    // value={paymentDetails.account_number}
                    value={"1231231231233"}
                    readOnly
                    ref={inputRef3}
                    disabled
                  />
                  <div
                    className="position-absolute copy-text"
                    style={{
                      right: "10px",
                      top: "60%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  >
                    <button onClick={() => handleCopy(inputRef3, setCopied3)}>
                      <i className="fa-solid fa-copy text-white fs-5"></i>
                    </button>
                    {copied3 && <span className="copied-tooltip">Copied</span>}
                  </div>
                </div>
                <div className="input-field mb-3">
                  <input
                    required
                    className="input"
                    type="text"
                    // value={paymentDetails.ifsc_code}
                    value={"SBIN0005943"}
                    readOnly
                    ref={inputRef4}
                    disabled
                  />
                  <div
                    className="position-absolute copy-text"
                    style={{
                      right: "10px",
                      top: "60%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  >
                    <button onClick={() => handleCopy(inputRef4, setCopied4)}>
                      <i className="fa-solid fa-copy text-white fs-5"></i>
                    </button>
                    {copied4 && <span className="copied-tooltip">Copied</span>}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Bank Details Ends*/}

          {/* Upload Data Starts */}
          {/* {amount && paymentSelectedMethod ? ( */}
          <div className="">
            <h5 className=" mb-0">Deposit Amount</h5>
            <h3 className="text-success">
              {CURRENCY_SYMBOL} {amount}
            </h3>
            {/* <h5 className="mb-3">
                You have selected the{" "}
                {paymentSelectedMethod === 1 ? "BANK" : "UPI"} payment method.
              </h5> */}
            {/* test starts */}

            {/* test Ends */}
            <form
              className="form-control_container"
              onSubmit={formik.handleSubmit}
            >
              {formik.errors.api &&
                (Array.isArray(formik.errors.api) ? (
                  <p className="text-danger ">
                    {formik.errors.api.map((err, index) => (
                      <li key={index}>{err}</li>
                    ))}
                  </p>
                ) : (
                  <p className="text-danger">{formik.errors.api}</p>
                ))}
              {/* <p>Testing</p>
                {formik.errors.api && (
                  <p className="text-danger">{formik.errors.api}</p>
                )} */}
              <div
                className="input-field mb-3 mt-3"
                style={{ display: "none" }}
              >
                <p className="mb-0">
                  You have selected {CURRENCY_SYMBOL}
                  {amount} to deposit.
                </p>
                <input
                  required
                  className="input readonly-input mt-1"
                  type="text"
                  name="amount"
                  value={formik.values.amount}
                  readOnly
                  disabled
                />
              </div>

              <div className="mb-2">
                <label
                  htmlFor="formFile"
                  className="form-label text-white mb-0"
                >
                  Payment Screenshot
                </label>
                <div className="custom-file-input" style={{ marginTop: 0 }}>
                  <label htmlFor="formFile">
                    <span className="btn">Upload File</span>
                    <span className="file-name">
                      {formik.values.payment_screenshot
                        ? formik.values.payment_screenshot.name
                        : "No file chosen"}
                    </span>
                  </label>
                  <input
                    type="file"
                    id="formFile"
                    className="form-control"
                    hidden
                    accept="image/*"
                    onChange={handleFileChange}
                  />
                </div>
              </div>

              <div className="input-field mb-3">
                <input
                  required
                  className="input"
                  type="text"
                  name="utr_number"
                  value={formik.values.utr_number}
                  // onChange={formik.handleChange}
                  onChange={(e) => {
                    formik.handleChange(e);
                    setFormData((prev) => ({
                      ...prev,
                      utr_number: e.target.value,
                    }));
                  }}
                  onBlur={formik.handleBlur}
                />
                <label className="label" htmlFor="utr_number">
                  Enter UTR No
                </label>
                {formik.touched.utr_number && formik.errors.utr_number && (
                  <p className="text-danger">{formik.errors.utr_number}</p>
                )}
              </div>

              <div className="d-flex justify-content-center">
                <button
                  type="submit"
                  className="btn btn-login w-25 mt mb- text-capitalize"
                  disabled={formik.isSubmitting}
                >
                  {formik.isSubmitting ? "Submitting ..." : "Submit"}
                </button>
              </div>
            </form>
          </div>

          {/* Upload Data Ends */}
        </form>
      </div>
    </div>
  );
};

export default SelectAmount;

/* ------------ helpers ------------ */

/**
 * Pick a “nice” step (…000) based on the range so we get clean values.
 * Targets ~2 interior buttons.
 */
function pickStep(min, max) {
  const range = max - min;
  if (range >= 200000) return 50000; // 50k steps
  if (range >= 100000) return 20000; // 20k steps
  if (range >= 50000) return 10000; // 10k steps
  if (range >= 20000) return 5000; // 5k steps
  if (range >= 10000) return 2000; // 2k steps
  return 1000; // 1k step fallback
}

function roundToStep(n, step) {
  return Math.round(n / step) * step;
}

/**
 * Generate exactly 4 buttons:
 * [min, niceMid1, niceMid2, max]
 * where the two mids are clean …000 numbers inside the range.
 */
function generateFourButtons(min, max) {
  const step = pickStep(min, max);

  // target mids around 1/3 and 2/3 of the range
  const t1 = min + (max - min) / 3;
  const t2 = min + (2 * (max - min)) / 3;

  let m1 = roundToStep(t1, step);
  let m2 = roundToStep(t2, step);

  // clamp to (min, max)
  m1 = Math.min(Math.max(m1, min), max);
  m2 = Math.min(Math.max(m2, min), max);

  // ensure they don't collide with min/max
  if (m1 === min) m1 = Math.min(m1 + step, max);
  if (m1 === max) m1 = Math.max(max - step, min);

  if (m2 === max) m2 = Math.max(m2 - step, min);
  if (m2 === min) m2 = Math.min(min + step, max);

  // if mids collide with each other, spread them by a step if possible
  if (m1 === m2) {
    const tryLeft = m1 - step;
    const tryRight = m2 + step;
    if (tryLeft > min) m1 = tryLeft;
    else if (tryRight < max) m2 = tryRight;
  }

  // build unique, sorted list with min & max guaranteed
  const set = new Set([min, m1, m2, max]);
  const arr = Array.from(set).sort((a, b) => a - b);

  // ensure exactly 4 entries: if we lost one due to collisions, fill using step grid
  if (arr.length < 4) {
    const first = Math.ceil(min / step) * step;
    for (let v = first; v <= max && arr.length < 4; v += step) {
      if (!arr.includes(v)) arr.splice(arr.length - 1, 0, v); // insert before max
    }
  }

  // if more than 4 (unlikely), trim to 4 while keeping min & max
  if (arr.length > 4) {
    const t1 = min + (max - min) / 3;
    const t2 = min + (2 * (max - min)) / 3;
    const mids = arr.slice(1, -1);
    mids.sort((a, b) => {
      const da = Math.min(Math.abs(a - t1), Math.abs(a - t2));
      const db = Math.min(Math.abs(b - t1), Math.abs(b - t2));
      return da - db;
    });
    return [arr[0], mids[0], mids[1], arr[arr.length - 1]].sort(
      (a, b) => a - b
    );
  }

  return arr;
}
